// extracted by mini-css-extract-plugin
export var notificationHost = "_kf-0";